interface ICopyToClipboardOptions {
  excludeOuterQuotes?: boolean;
  copyRaw?: boolean;
}

export const copyToClipboard = function (
  data: string,
  { excludeOuterQuotes = false, copyRaw = false }: ICopyToClipboardOptions = {},
): void {
  const value = copyRaw ? data : JSON.stringify(data);
  const textToCopy = excludeOuterQuotes && !copyRaw ? value.slice(1, -1) : value;

  // Use modern Clipboard API with fallback to legacy method
  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(textToCopy).catch(() => {
      // Fallback to legacy method if Clipboard API fails
      copyViaTextarea(textToCopy);
    });
  } else {
    // Fallback for browsers without Clipboard API
    copyViaTextarea(textToCopy);
  }
};

function copyViaTextarea(text: string): void {
  const el = document.createElement('textarea');
  el.value = text;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
}
